import DefaultValidation from '@/services/validations/DefaultValidation';
import { isNull } from '@/functions/Util';

export default class FlexValidation extends DefaultValidation {
    validate(contaFlex, refs) {
        let validated = true;

        if (isNull(contaFlex.idEmpresa)) {
            refs.empresaSelected.focusedOut = true;
            validated = false;
        }

        if (isNull(contaFlex.idUsuario)) {
            refs.colaboradorSelected.focusedOut = true;
            validated = false;
        }

        if(isNull(contaFlex.flexLancamento.idMotivo)) {
            refs.motivoSelected.focusedOut = true;
            validated = false;
        }
        
        if(isNull(contaFlex.flexLancamento.observacao) && refs.observacaoInput.required) {
            refs.observacaoInput.focusedOut = true;
            validated = false;
        }

        if (isNull(contaFlex.regraTrabalho)) {
            refs.regraTrabalhoInput.focusedOut = true;
            validated = false;
        }

        if (isNull(contaFlex.operacao) && refs.operacaoInput) {
            refs.operacaoInput.focusedOut = true;
            validated = false;
        }

        if (isNull(contaFlex.cota) || (contaFlex.cota > 100 || contaFlex.cota < 0)) {
            refs.cotaInput.focusedOut = true;
            validated = false;
        }

        if (isNull(contaFlex.valorMinimo)) {
            refs.valorMinimoInput.focusedOut = true;
            validated = false;
        }

        if (isNull(contaFlex.flexLancamento.saldoGerado)) {
            refs.valorInput.focusedOut = true;
            validated = false;
        }

        return validated;
    }
}
